module.exports = __webpack_public_path__ + "img/mid.4e58f9a1.svg";